var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('provider-form',{attrs:{"provider-id":_vm.providerId,"details":_vm.details},on:{"submit":_vm.updateProvider,"close":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }